import Search16 from '@carbon/icons-react/es/search/16';
import React from 'react';
import {
  components as ReactSelectComponents,
  IndicatorProps,
} from 'react-select';
import styled from 'styled-components';
import { FieldOptionBase } from 'api/tasks';
import { ActionPanel } from 'components/molecules/action-panel';
import { StyledSelect } from 'components/organisms/tasks/field-value/styled-select';

const { Popover: CommonPopover } = ActionPanel;

const PopoverComponent = styled(CommonPopover)`
  font-family: var(--ozn-font-sans);
  width: 296px;
  height: min-content;
  overflow: hidden;
`;

const Popover: typeof CommonPopover = PopoverComponent as any;

Popover.Title = CommonPopover.Title;

const DropdownIndicator = (props: IndicatorProps<FieldOptionBase, true>) => (
  <ReactSelectComponents.DropdownIndicator {...props}>
    <Search16 style={{ marginRight: 8 }} />
  </ReactSelectComponents.DropdownIndicator>
);

const Select = styled(StyledSelect).attrs(({ components = {} }) => ({
  menuIsOpen: true,
  hideSelectedOptions: false,
  components: {
    DropdownIndicator,
    ...components,
  },
}))`
  font-family: var(--ozn-font-sans);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ozone-select__control {
    margin: 0 var(--popover-spacing) var(--popover-spacing);
    flex: 1 0 auto;
  }

  .ozone-select__menu {
    border: none;
    box-shadow: none;
    position: initial;
    margin: 0;
    flex: 1 1 100%;
    overflow-y: auto;
  }

  .ozone-select__menu-list {
    max-height: 100%;
  }

  .ozone-select__value-container {
    min-height: 40px;
    max-height: 76px;
    overflow: hidden;
    overflow-y: auto;
  }

  .ozone-select__indicators {
    .ozone-select__indicator-separator {
      display: none;
    }

    .ozone-select__dropdown-indicator {
      display: initial;
    }
  }

  .ozone-select__option {
    cursor: pointer;
  }
`;

export { Popover, Select };
